import { Component, OnInit, inject, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faBuilding, faUser, faLock, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { environment } from '../../../environments/environment';
import { buildVersionDate, buildVersionNumber } from '../../../environments/version';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FontAwesomeModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  private router = inject(Router);
  private formBuilder = inject(FormBuilder);
  private authService = inject(AuthService);

  produccion = environment.production;
  nombreProyecto = 'Dashboard SQL Report';
  versionApp = `${buildVersionDate ?? ''} ${buildVersionNumber ?? ''}`.trim();

  showPassword = signal<boolean>(false);
  loading = signal<boolean>(false);
  errorMsg = signal<string>('');

  faBuilding = faBuilding;
  faUser = faUser;
  faLock = faLock;
  faEye = faEye;
  faEyeSlash = faEyeSlash;

  authForm = this.formBuilder.group({
    ruc: ['', [Validators.required, Validators.maxLength(11)]],
    nomuser: ['', Validators.required],
    clave: ['', Validators.required]
  });

  usersesion = input<string>('');

  ngOnInit(): void {
    const encoded = this.usersesion();
    if (encoded) this.applyUserSession(encoded);
  }

  private applyUserSession(encoded: string): void {
    try {
      const normalized = encoded.replace(/-/g, '+').replace(/_/g, '/');
      const decoded = JSON.parse(atob(normalized)) as { ruc?: string; coduser?: string; codsuc?: string };
      if (decoded.ruc && decoded.coduser) {
        this.authForm.patchValue({
          ruc: decoded.ruc,
          nomuser: decoded.coduser
        });
      }
    } catch (e) {
      console.error('Error al decodificar usersesion:', e);
    }
  }

  togglePassword(): void {
    this.showPassword.set(!this.showPassword());
  }

  validacion(field: string): boolean {
    const control = this.authForm.get(field);
    return !!(control && control.touched && control.errors);
  }

  authUser(): void {
    if (this.authForm.invalid) {
      this.authForm.markAllAsTouched();
      return;
    }
    const { ruc, nomuser, clave } = this.authForm.value;
    this.loading.set(true);
    this.errorMsg.set('');
    this.authService.auth(ruc!, nomuser!, clave!).subscribe({
      next: (resp) => {
        this.loading.set(false);
        if (resp.status === 200 && resp.body) {
          this.router.navigate(['/']);
        } else {
          this.errorMsg.set('Respuesta de autenticación inválida.');
        }
      },
      error: (err) => {
        this.loading.set(false);
        const msg =
          (err?.error && (typeof err.error === 'string' ? err.error : err.error?.message)) ||
          err?.message ||
          'No se pudo iniciar sesión.';
        this.errorMsg.set(msg);
      }
    });
  }
}
